import { EThemesOG } from '@/constants/themeConfig';
import { getThemeName } from '@/helpers/getThemeConfig';
import AccountVerification from './AccountVerification';
import AccountVerificationNew from './AccountVerificationNew';

const themeName = getThemeName();

/**
 * Don't add to this list
 */
const legacyBuildBookies = [
  EThemesOG.Wellbet,
  EThemesOG.Betgalaxy,
  EThemesOG.Questbet,
  EThemesOG.Betroyale,
  EThemesOG.Volcanobet,
  EThemesOG.Fiestabet,
  EThemesOG.Puntgenie,
  EThemesOG.Betprofessor,
];

export default legacyBuildBookies.includes(themeName)
  ? AccountVerification
  : AccountVerificationNew;
